export interface PersonSelection {
  id: number;
  name: string;
  type: SettlementAccountOwnerType;
  dob: Date;
  role?: string;
}




export class SettlementAccountOwnerDto {
    public personId: number = 0;
    public name: string = '';
    public type: SettlementAccountOwnerType;
    public dob: Date;
    public role?: string;
}

export enum SettlementAccountOwnerType {
    Owner,
    BoardMember
}


export enum SettlementAccountValidationStatus
{
    Pending,
    BankIdCheckCompleted,
    BankIdCheckFailed,
    PersonMatchedWithBankId,
    PersonNotMatchedWithBankId,
    KarCheckFailed,
    Success
}